function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;} /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * During refactor of NPR feature out of the render context
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Created the RenderContextExtension as base interface class for extension developers to consume
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * And we will integrate the RenderContextExtension into main RenderContext as a valid extension 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * to allow other developers to implement their own post process rendering effect
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */var
RenderContextPostProcessExtension = /*#__PURE__*/function () {
  function RenderContextPostProcessExtension(renderContext, viewer) {_classCallCheck(this, RenderContextPostProcessExtension);
    this.viewer = viewer;
    this.renderContext = renderContext;
    this.postProcPass = null;
    this.postProcShaded = false;

    this.setGlobalManager(viewer.globalManager);
  }

  /**
     * lifecycle function
     */_createClass(RenderContextPostProcessExtension, [{ key: "load", value: function load()
    {
    }

    /**
       * lifecycle function
       */ }, { key: "unload", value: function unload()
    {
      this.viewer = null;
      this.renderContext = null;
      this.postProcPass = null;
    }

    /**
       * Enable post processing pass
       */ }, { key: "enable", value: function enable()
    {
      this.setPostProcShaded(true);

      var _settings = this.renderContext.settings;

      this.renderContext.initPostPipeline(_settings.sao, _settings.antialias);

      // Necessary in order to update MRT flags.
      this.viewer.impl.fireRenderOptionChanged();

      this.viewer.impl.invalidate(true, true, true);
    }

    /**
       * Disable post processing pass
       */ }, { key: "disable", value: function disable()
    {
      this.setPostProcShaded(false);

      this.viewer.impl.invalidate(false, false, true);
    } }, { key: "shouldRenderAfterOverlays", value: function shouldRenderAfterOverlays()

    {
      return false;
    }

    /**
       * Render function
       * @param {WebGLRender} renderer 
       * @param {WebGLRenderTarget} outTarget 
       * @param {WebGLRenderTarget} inTarget 
       * @param {WebGLRenderTarget} overlaysRendered
       */ }, { key: "render", value: function render(
    renderer, outTarget, inTarget, overlaysRendered) {
      var overlaysRenderedVerified = overlaysRendered === undefined || overlaysRendered === this.shouldRenderAfterOverlays();
      var shouldRender = this.isPostProcShaded() && overlaysRenderedVerified;

      if (shouldRender) {
        this.postProcPass.render(renderer, outTarget, inTarget);
        return true;
      }

      return false;
    }

    /**
       * Change shader uniform value
       * @param {string} key 
       * @param {any} value 
       * @param {boolean} usingCopy 
       */ }, { key: "updateUniformValue", value: function updateUniformValue(
    key, value, usingCopy) {
      if (!this.postProcPass.uniforms[key]) {
        return;
      }

      if (usingCopy) {
        this.postProcPass.uniforms[key].value.copy(value);
      } else {
        this.postProcPass.uniforms[key].value = value;
      }

      this.viewer.impl.invalidate(false, false, true);
    }

    /**
       * Change shader define value
       * @param {string} key 
       * @param {any} value 
       */ }, { key: "updateDefineValue", value: function updateDefineValue(
    key, value) {
      if (this.postProcPass.material.defines[key] !== value) {
        if (value !== null) {
          this.postProcPass.material.defines[key] = value;
        } else {
          delete this.postProcPass.material.defines[key];
        }

        this.setMaterialNeedsUpdate();
      }
    }

    /**
       * Get uniform value
       */ }, { key: "getUniformValue", value: function getUniformValue(
    key) {
      return this.postProcPass.uniforms[key].value;
    }

    /**
       * Get define value
       */ }, { key: "getDefineValue", value: function getDefineValue(
    key) {
      return this.postProcPass.material.defines[key];
    }

    /**
       * Update RenderPass resolutions
       * @param {int} resX 
       * @param {int} resY 
       */ }, { key: "changeResolution", value: function changeResolution(
    resX, resY) {
      this.postProcPass.uniforms["resolution"].value.set(resX, resY);
    }

    /**
       * Call when we need to update the material
       */ }, { key: "setMaterialNeedsUpdate", value: function setMaterialNeedsUpdate()
    {
      this.postProcPass.material.needsUpdate = true;
      this.viewer.impl.invalidate(false, false, true);
    }

    /**
       * return true if the edges on
       * @returns boolean
       */ }, { key: "postProcessEdgesOn", value: function postProcessEdgesOn()
    {
      return false;
    } }, { key: "setPostProcShaded", value: function setPostProcShaded(

    enable) {
      this.postProcShaded = enable;
    }

    // Is post process enabled.
  }, { key: "isPostProcShaded", value: function isPostProcShaded() {
      return this.postProcShaded;
    }

    // Used to determine the order of rendering.
  }, { key: "getOrder", value: function getOrder() {
      return 0;
    } }]);return RenderContextPostProcessExtension;}();


/**
                                                         * This class is used to work as an RenderContext Post Processing Shading Manager
                                                         * 
                                                         */var
RenderContextPostProcessManager = /*#__PURE__*/function () {

  function RenderContextPostProcessManager() {_classCallCheck(this, RenderContextPostProcessManager);
    // RenderContext extensions array.
    this.rcExtensions = [];
  }
  /**
     * Register the real PostProcessExtension instance
     * 
     * @param {RenderContextPostProcessExtension} rcExtension 
     */_createClass(RenderContextPostProcessManager, [{ key: "registerPostProcessingExtension", value: function registerPostProcessingExtension(
    rcExtension) {
      this.rcExtensions.push(rcExtension);

      // Sort according to extension's order. The lower the order value the sooner it will get renderer.
      this.rcExtensions.sort(function (a, b) {return b.getOrder() - a.getOrder();});
    }

    /**
       * Remove the PostProcessExtension instance
       */ }, { key: "removePostProcessingExtension", value: function removePostProcessingExtension(
    rcExtension) {
      var index = this.rcExtensions.indexOf(rcExtension);

      if (index !== -1) {
        rcExtension.unload();
        this.rcExtensions.splice(index, 1);
      }
    } }, { key: "render", value: function render(

    renderer, outTarget, inTarget, tmpTarget, overlaysRendered) {
      for (var i = 0; i < this.rcExtensions.length; i++) {
        var rendered = this.rcExtensions[i].render(renderer, outTarget, inTarget, overlaysRendered);

        // Swap targets in order to accumulate the passes.
        if (rendered) {
          inTarget = outTarget;

          var t = outTarget;
          outTarget = tmpTarget;
          tmpTarget = t;
        }
      }

      return inTarget;
    } }, { key: "updateUniformValue", value: function updateUniformValue(

    key, value, usingCopy) {
      for (var i = 0; i < this.rcExtensions.length; i++) {
        this.rcExtensions[i].updateUniformValue(key, value, usingCopy);
      }
    } }, { key: "changeResolution", value: function changeResolution(

    resX, resY) {
      for (var i = 0; i < this.rcExtensions.length; i++) {
        this.rcExtensions[i].changeResolution(resX, resY);
      }
    } }, { key: "setMaterialNeedsUpdate", value: function setMaterialNeedsUpdate()

    {
      for (var i = 0; i < this.rcExtensions.length; i++) {
        this.rcExtensions[i].setMaterialNeedsUpdate();
      }
    } }, { key: "postProcessEdgesOn", value: function postProcessEdgesOn()

    {
      return this.rcExtensions.some(function (ext) {return ext.postProcessEdgesOn();});
    } }, { key: "isPostProcShaded", value: function isPostProcShaded()

    {
      return this.rcExtensions.some(function (ext) {return ext.isPostProcShaded();});
    } }]);return RenderContextPostProcessManager;}();



export { RenderContextPostProcessExtension, RenderContextPostProcessManager };